export default {
  /*
   * index() lista las estimaciones en tiempo real de una parada valencia
   */
  index(params) {
    return Vue.http.get('tracking/real_time_stop_estimations', params).then(response => response.data || response)
  }
}
